"use strict";

import { InstagramFilled } from "@ant-design/icons-vue";
import { Facebook } from "lucide-vue-next";

export default {
  name: "Footer",

  components: {
    InstagramFilled,
    Facebook,
  },
};
